<template>
    <div class="container">
        <b-modal
            :model-value="showEditMasivo"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-multiple-accounts-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Criterios de búsqueda -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.criterio }} (Cuenta)</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="critCuenta" 
                            @input="buscaCuenta"
                            type="text"
                            class="form-input"
                            placeholder="Buscar cuenta..."
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.criterio }} (Descripción)</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="critDescripcion" 
                            @input="buscaDescripcion"
                            type="text"
                            class="form-input"
                            placeholder="Buscar descripción..."
                        />
                    </b-col>
                </b-row>

                <!-- Selección múltiple de cuentas -->
                <b-row class="d-flex align-items-start uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.cuenta }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="multiselect-container">
                            <div class="multiselect-header">
                                <b-form-checkbox 
                                    v-model="selectAll" 
                                    @change="toggleSelectAll"
                                    :indeterminate="isIndeterminate"
                                >
                                    {{ selectAll ? labels.deselectAll : labels.selectAll }}
                                </b-form-checkbox>
                                <span class="selected-count">{{ listCuentasSel?.length }} {{ labels.selected }}</span>
                            </div>
                            <div class="multiselect-list" ref="multiselectList">
                                <div 
                                    v-for="cuenta in listCuentas" 
                                    :key="cuenta.id" 
                                    class="multiselect-item"
                                >
                                    <b-form-checkbox 
                                        v-model="listCuentasSel" 
                                        :value="cuenta.cuenta"
                                        @change="updateSelectAllState"
                                    >
                                        <span class="account-code">{{ cuenta?.cuenta }}</span>
                                        <span class="account-description">- {{ cuenta?.descripcion }}</span>
                                    </b-form-checkbox>
                                </div>
                            </div>
                            <div class="multiselect-footer">
                                <span class="text-muted small">
                                    {{ listCuentas.length }} {{ labels.accounts }} disponibles
                                </span>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!-- Campo a modificar -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.fieldToModify }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="campoAModificar"
                            class="form-input"
                            @change="resetCampos"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.sel }} --
                                </b-form-select-option>
                            </template>
                            <b-form-select-option value="niif">{{ labels.niif }}</b-form-select-option>
                            <b-form-select-option value="booleanos">{{ labels.esf }}/{{ labels.eri }}/{{ labels.efe }}/{{ labels.ecp }}</b-form-select-option>
                            <b-form-select-option value="interco">{{ labels.interco }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Niif - Solo visible cuando se selecciona -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="campoAModificar === 'niif'">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="niifSel"
                            class="form-input"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.sel }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="planCons.id" 
                                :value="planCons.niif" 
                                v-for="planCons in listNiif"
                            >
                                {{ planCons?.niif }} - {{ planCons?.nameNiif }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Opciones booleanas -->
                <div v-if="campoAModificar === 'booleanos'">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.esf }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="esf" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.eri }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="eri" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.efe }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="efe" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.ecp }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="ecp" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </div>

                <!-- Interco - Solo visible cuando se selecciona -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="campoAModificar === 'interco'">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.interco }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="interco" class="form-input">
                            <b-form-select-option value="">{{ labels.noGroup }}</b-form-select-option>
                            <option 
                                :key="grupo.interco" 
                                :value="grupo.interco" 
                                v-for="grupo in gruposInterco"
                            >
                                {{ grupo?.descripcion }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Información del campo seleccionado -->
                <div class="info-box" v-if="campoAModificar && listCuentasSel.length > 0">
                    <div class="info-icon">ℹ️</div>
                    <div class="info-text">
                        <strong>{{ labels.modification }}:</strong>
                        <span v-if="campoAModificar === 'niif'">
                            {{ labels.updateNiif }} "{{ getNiifName(niifSel) }}" {{ labels.for }} <strong>{{ listCuentasSel?.length }}</strong> {{ labels.accounts }}
                        </span>
                        <span v-else-if="campoAModificar === 'booleanos'">
                            {{ labels.updateBoolean }} <strong>{{ listCuentasSel?.length }}</strong> {{ labels.accounts }}
                        </span>
                        <span v-else-if="campoAModificar === 'interco'">
                            {{ labels.updateInterco }} "{{ getIntercoName(interco) }}" {{ labels.for }} <strong>{{ listCuentasSel.length }}</strong> {{ labels.accounts }}
                        </span>
                    </div>
                </div>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeDialog">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmSave" :disabled="isSaving || !campoAModificar || listCuentasSel.length === 0">
                        <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>
                        {{ isSaving ? labels.saving : labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Confirmación Eliminar -->
        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDelete" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import PlanCuentas from '../../services/PlanCuentas'
import GruposIntercos from '../../services/GruposIntercos'
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "EditaVariasCuentas",
    components: {
        InacticaItem
    },
    props: ['showEditMasivo', 'compVigSelect', 'listadoCuentas', 'listadoNiif'],
    data: () => ({
        listCuentasSel: [],
        campoAModificar: "",
        niifSel: "",
        esf: null,
        eri: null,
        efe: null,
        ecp: null,
        interco: "",
        critCuenta: "",
        listCuentas: [],
        listNiif: [],
        critDescripcion: "",
        selectAll: false,
        isSaving: false,
        hasUnsavedChanges: false,
        gruposInterco: [],
        showDeleteModal: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar Cuentas Masivamente",
                    save: "Guardar",
                    saving: "Guardando...",
                    close: "Cerrar",
                    cuenta: "Cuentas",
                    name: "Nombre",
                    niif: "NIIF",
                    esf: "ESF",
                    eri: "ERI",
                    efe: "EFE",
                    ecp: "ECP",
                    interco: "Interco",
                    sel: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    criterio: "Criterio",
                    selectAll: "Seleccionar todo",
                    deselectAll: "Deseleccionar todo",
                    selected: "seleccionadas",
                    noGroup: "NO",
                    fieldToModify: "Campo a modificar",
                    modification: "Modificación",
                    updateNiif: "Se actualizará el NIIF a",
                    updateBoolean: "Se actualizarán los campos booleanos para",
                    updateInterco: "Se actualizará el Interco a",
                    for: "para",
                    accounts: "cuenta(s)",
                    infoTitle: "Edición masiva de cuentas",
                    infoText: "Selecciona las cuentas a modificar y el campo a actualizar."
                }
            } else {
                return {
                    title: "Mass Edit Accounts",
                    save: "Save",
                    saving: "Saving...",
                    close: "Close",
                    cuenta: "Accounts",
                    name: "Name",
                    niif: "NIIF",
                    esf: "ESF",
                    eri: "ERI",
                    efe: "EFE",
                    ecp: "ECP",
                    interco: "Interco",
                    sel: "Select...",
                    yes: "Yes",
                    not: "No",
                    criterio: "Criterion",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    selected: "selected",
                    noGroup: "NO",
                    fieldToModify: "Field to modify",
                    modification: "Modification",
                    updateNiif: "NIIF will be updated to",
                    updateBoolean: "Boolean fields will be updated for",
                    updateInterco: "Interco will be updated to",
                    for: "for",
                    accounts: "account(s)",
                    infoTitle: "Mass edit accounts",
                    infoText: "Select the accounts to modify and the field to update."
                }
            }
        },
        isIndeterminate() {
            if (this.listCuentas.length === 0) return false
            const selectedCount = this.listCuentas.filter(cuenta => 
                this.listCuentasSel.includes(cuenta.cuenta)
            ).length
            return selectedCount > 0 && selectedCount < this.listCuentas.length
        }
    },
    watch: {
        showEditMasivo(val) {
            if (val == true) {
                this.listCuentas = this.listadoCuentas
                this.listNiif = this.listadoNiif
                this.hasUnsavedChanges = false
                this.loadGruposInterco().then(() => {})
            }
        },
        listCuentasSel: {
            handler() {
                this.updateSelectAllState()
                this.hasUnsavedChanges = true
            },
            deep: true
        },
        campoAModificar() {
            this.hasUnsavedChanges = true
        },
        niifSel() {
            this.hasUnsavedChanges = true
        },
        esf() {
            this.hasUnsavedChanges = true
        },
        eri() {
            this.hasUnsavedChanges = true
        },
        efe() {
            this.hasUnsavedChanges = true
        },
        ecp() {
            this.hasUnsavedChanges = true
        },
        interco() {
            this.hasUnsavedChanges = true
        }
    },
    methods: {
        closeDeleteModal() {
            this.showDeleteModal = false
        },
        
        confirmDelete() {
            this.showDeleteModal = false
        },
        
        confirmSave() {
            if (this.listCuentasSel.length === 0) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar al menos una cuenta"
                    : "You must select at least one account")
                return
            }
            if (!this.campoAModificar) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un campo a modificar"
                    : "You must select a field to modify")
                return
            }
            if (this.campoAModificar === 'niif' && !this.niifSel) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un valor para NIIF"
                    : "You must select a value for NIIF")
                return
            }
            if (this.campoAModificar === 'interco' && this.interco === undefined) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un valor para Interco"
                    : "You must select a value for Interco")
                return
            }
            
            this.editPlanCuenta()
        },
        
        getCampoNombre() {
            switch (this.campoAModificar) {
                case 'niif': return this.labels.niif
                case 'booleanos': return `${this.labels.esf}/${this.labels.eri}/${this.labels.efe}/${this.labels.ecp}`
                case 'interco': return this.labels.interco
                default: return ''
            }
        },
        
        editPlanCuenta() {
            this.isSaving = true
            
            let datos = {
                'listCuentas': this.listCuentasSel,
                'vigencia': this.compVigSelect.vigencia,
                'companyId': this.compVigSelect.companyId,
                'codReporte': this.compVigSelect.codReporte
            }
            
            switch (this.campoAModificar) {
                case 'niif':
                    datos.niif = this.niifSel
                    break
                case 'booleanos':
                    datos.esf = this.esf
                    datos.eri = this.eri
                    datos.efe = this.efe
                    datos.ecp = this.ecp
                    break
                case 'interco':
                    datos.interco = this.interco === '' ? null : this.interco
                    break
            }
            
            // Validar que al menos un campo fue modificado
            if (this.campoAModificar === 'booleanos') {
                const hayCambiosBooleanos = ['esf', 'eri', 'efe', 'ecp'].some(campo =>
                    datos[campo] !== null && datos[campo] !== undefined
                )
                if (!hayCambiosBooleanos) {
                    this.$toast.error(this.$store.state._language == "es-ES"
                        ? "Debe modificar al menos un campo booleano"
                        : "You must modify at least one boolean field")
                    this.isSaving = false
                    return
                }
            }
            
            PlanCuentas.planCuentasMassiveUpdate(datos)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message)
                        this.hasUnsavedChanges = false
                        setTimeout(() => {
                            this.reloadTbl()
                        }, 2000)
                    }
                })
                .catch((err) => {
                    console.log("Error completo:", err)
                    this.$toast.error(this.$store.state._language == "es-ES"
                        ? "Error al actualizar las cuentas"
                        : "Error updating accounts")
                    this.isSaving = false
                })
        },
        
        getNiifName(niifValue) {
            const niif = this.listNiif.find(n => n.niif === niifValue)
            return niif ? `${niif.niif}-${niif?.nameNiif}` : ''
        },
        
        getIntercoName(intercoValue) {
            if (intercoValue === '') return this.labels.noGroup
            const grupo = this.gruposInterco.find(g => g.interco === intercoValue)
            return grupo ? grupo?.descripcion : ''
        },
        
        resetCampos() {
            this.niifSel = ""
            this.esf = null
            this.eri = null
            this.efe = null
            this.ecp = null
            this.interco = ""
        },
        
        reloadTbl() {
            this.$emit('reload', this.compVigSelect.vigencia, this.compVigSelect.companyId, this.compVigSelect.codReporte)
            this.clearCampos()
            this.$emit('clicked', false)
        },
        
        clearCampos() {
            this.listCuentasSel = []
            this.campoAModificar = ""
            this.niifSel = ""
            this.esf = null
            this.eri = null
            this.efe = null
            this.ecp = null
            this.interco = ""
            this.critCuenta = ""
            this.critDescripcion = ""
            this.selectAll = false
            this.isSaving = false
            this.hasUnsavedChanges = false
        },
        
        buscaCuenta() {
            const criterio = "^" + this.critCuenta
            if (this.critCuenta.length == 0) {
                this.listCuentas = this.listadoCuentas
            } else {
                this.listCuentas = this.listadoCuentas.filter(
                    (cuenta) => cuenta.cuenta.match(criterio) > 0)
            }
            this.updateSelectAllState()
        },
        
        buscaDescripcion() {
            if (this.critDescripcion.length == 0) {
                this.listCuentas = this.listadoCuentas
            } else {
                this.listCuentas = this.listadoCuentas.filter(
                    (cuenta) => cuenta.descripcion.toUpperCase().indexOf(this.critDescripcion.toUpperCase()) >= 0)
            }
            this.updateSelectAllState()
        },
        
        toggleSelectAll() {
            if (this.selectAll) {
                this.listCuentasSel = this.listCuentas.map(cuenta => cuenta.cuenta)
            } else {
                this.listCuentasSel = []
            }
            this.updateSelectAllState()
        },
        
        updateSelectAllState() {
            if (this.listCuentas.length === 0) {
                this.selectAll = false
                return
            }
            const allSelected = this.listCuentas.every(cuenta =>
                this.listCuentasSel.includes(cuenta.cuenta))
            this.selectAll = allSelected
        },
        
        async loadGruposInterco() {
            try {
                const res = await GruposIntercos.getAllGruposIntercos()
                this.gruposInterco = res.data.gruposIntercos || []
                return this.gruposInterco
            } catch (err) {
                console.error("Error loading grupos interco:", err)
                this.gruposInterco = []
                return []
            }
        },
        
        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?"
                if (window.confirm(message)) {
                    this.clearCampos()
                    this.$emit('clicked', false)
                }
            } else {
                this.clearCampos()
                this.$emit('clicked', false)
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
.multiselect-container {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
    background: white;
}

.multiselect-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 14px;
    background-color: #f5f6f8;
    border-bottom: 1px solid #e0e0e0;
}

.multiselect-header .custom-control-label {
    font-weight: 500;
    font-size: 14px;
}

.selected-count {
    font-size: 13px;
    color: #666;
    font-weight: 500;
}

.multiselect-list {
    max-height: 280px;
    overflow-y: auto;
    min-height: 150px;
}

.multiselect-list::-webkit-scrollbar {
    width: 6px;
}

.multiselect-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.multiselect-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.multiselect-list::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.multiselect-item {
    padding: 6px 14px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.15s ease;
}

.multiselect-item:hover {
    background-color: #f8f9fa;
}

.multiselect-item:last-child {
    border-bottom: none;
}

.multiselect-item .custom-control {
    margin: 0;
    padding: 0;
}

.multiselect-item .custom-control-label {
    font-size: 14px;
    line-height: 1.4;
    padding-top: 2px;
    cursor: pointer;
}

.multiselect-item .custom-control-label::before {
    top: 4px;
}

.multiselect-item .custom-control-label::after {
    top: 4px;
}

.account-code {
    font-weight: 600;
    color: #2c3e50;
}

.account-description {
    color: #555;
}

.multiselect-footer {
    padding: 6px 14px;
    background-color: #fafafa;
    border-top: 1px solid #e0e0e0;
    text-align: right;
}

.multiselect-footer .text-muted {
    font-size: 12px;
    color: #888;
}

/* Estilos para el checkbox indeterminado */
.multiselect-header .custom-control-input:indeterminate ~ .custom-control-label::before {
    background-color: #3498db;
    border-color: #3498db;
}

.info-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 18px;
    background: #e3f2fd;
    border: 1px solid #2196f3;
    border-radius: 6px;
    margin-top: 16px;
}

.info-icon {
    font-size: 18px;
    flex-shrink: 0;
}

.info-text {
    color: #1565c0;
    font-size: 14px;
    line-height: 1.5;
}

.info-text strong {
    color: #0d47a1;
}

@media (max-width: 768px) {
    .multiselect-list {
        max-height: 200px;
        min-height: 100px;
    }
    
    .multiselect-item .custom-control-label {
        font-size: 13px;
    }
}
</style>